/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type VerifyEmailCommandError = "VALIDATIONERROR" | "VERIFICATIONERROR" | "%future added value";
export type verifyEmailMutationVariables = {
    code: string;
};
export type verifyEmailMutationResponse = {
    readonly verifyLicensingAccountEmail: {
        readonly token: string | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: VerifyEmailCommandError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type verifyEmailMutation = {
    readonly response: verifyEmailMutationResponse;
    readonly variables: verifyEmailMutationVariables;
};



/*
mutation verifyEmailMutation(
  $code: String!
) {
  verifyLicensingAccountEmail(code: $code) {
    token
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "code"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "code",
                    "variableName": "code"
                }
            ],
            "concreteType": "VerifyLicensingAccountEmail",
            "kind": "LinkedField",
            "name": "verifyLicensingAccountEmail",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "token",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfVerifyEmailCommand",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "verifyEmailMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "verifyEmailMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "fd15951517aea1a1ea66bfd3ddfdd313",
            "id": null,
            "metadata": {},
            "name": "verifyEmailMutation",
            "operationKind": "mutation",
            "text": "mutation verifyEmailMutation(\n  $code: String!\n) {\n  verifyLicensingAccountEmail(code: $code) {\n    token\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '826946c12e495171fb2c8349edf5b1f5';
export default node;
